// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__MKBAV","title":"styles_title__DD5Ym","flexContainer":"styles_flexContainer__bh_BX"};